<template>
  <div class="sideMenu">
    <v-btn dark block color="accent" @click.stop="closeClick">Close</v-btn>
    <v-expansion-panel expand>
    <v-expansion-panel-content v-for="(templateCat) in AppState.blockTemplates" :key="templateCat.type" v-bind:value="true">
      <div slot="header" v-text="templateCat.title"></div>
      <a href="#" v-for="(template) in templateCat.templates" :key="template.id"  @click.stop.prevent="addBlock(template)" :title="template.title" 
      :style="{ opacity: navUsed && template.type === 'nav' ? '0.3' : '1' }">
        <img :src="'static/templates/theme1/' + template.template + '.jpg'" alt="">
        <div v-show="template.firebase && !isJson(AppState.currentProject.firebaseConfig)" class="side-block-disabled">Need to add Firebase details in Project Settings</div>
      </a>
    </v-expansion-panel-content>
  </v-expansion-panel>
  </div>
</template>

<script>
import AppState from "../util/AppState";
import { isJson } from "../util/utilities";

export default {
  data() {
    return {
      AppState,
      isJson
    };
  },
  computed: {
    navUsed() {
      let used = false;
      if (AppState.currentPage.blocks) {
        AppState.currentPage.blocks.forEach(block => {
          if (block.type === "nav") used = true;
        });
      }
      return used;
    }
  },
  methods: {
    addBlock(b) {
      if (
        !(this.navUsed && b.type === "nav") &&
        !(b.firebase && !isJson(AppState.currentProject.firebaseConfig))
      ) {
        this.$emit("addBlock", b);
      }
    },
    closeClick() {
      this.$emit("closeClick");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.sideMenu a {
  display: block;
  position: relative;
  width: 100%;
  padding: 10px 0;
}
.sideMenu img {
  display: block;
  width: 100%;
}
.sideMenu .side-block-disabled {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  padding: 20px;
  text-align: center;
  font-size: 1.3em;
}
.expansion-panel {
  box-shadow: none;
}
.expansion-panel__header:hover {
  background: #4c4c4c;
}
.theme--dark .expansion-panel .expansion-panel__container {
  border: none;
}
.expansion-panel__body a:hover img {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue